import { useMutation, useQuery } from '@tanstack/react-query'
import { ProductExcelExportsFilterParams, CreateProductExcelExportParams } from '@/types/product-excel-export'
import { useProductExcelExportsStore } from '@/store'
import { useBulkDeleteSuccessHandler } from './use-bulk-delete'

export const useProductExcelExports = (params: ProductExcelExportsFilterParams) => {
  const fetchProductExcelExports = useProductExcelExportsStore(state => state.fetchProductExcelExports)

  return useQuery({
    queryKey: ['productExcelExports', params],
    queryFn: () => fetchProductExcelExports(params),
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000
  })
}

export const useProductExcelExport = (id: string) => {
  const getProductExcelExport = useProductExcelExportsStore(state => state.getProductExcelExport)

  return useQuery({
    queryKey: ['productExcelExport', id],
    queryFn: () => getProductExcelExport(id),
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    enabled: !!id
  })
}

export const useCreateProductExcelExport = () => {
  const createProductExcelExport = useProductExcelExportsStore(state => state.createProductExcelExport)

  return useMutation({
    mutationFn: (params: CreateProductExcelExportParams) => createProductExcelExport(params),
    onSuccess: () => {}
  })
}

export const useDeleteProductExcelExport = () => {
  const deleteProductExcelExport = useProductExcelExportsStore(state => state.deleteProductExcelExport)

  return useMutation({
    mutationFn: (id: string) => deleteProductExcelExport(id),
    onSuccess: () => {}
  })
}

export const useBulkDeleteProductExcelExports = () => {
  const bulkDeleteProductExcelExports = useProductExcelExportsStore(state => state.bulkDeleteProductExcelExports)
  const deselectAllProductExcelExports = useProductExcelExportsStore(state => state.deselectAllProductExcelExports)
  const handleBulkDeleteSuccess = useBulkDeleteSuccessHandler()

  return useMutation({
    mutationFn: (ids: string[]) => bulkDeleteProductExcelExports(ids),
    onSuccess: response => {
      deselectAllProductExcelExports()
      handleBulkDeleteSuccess(response)
    }
  })
}
